export default {
    push: {
        turnOn: 'Turn on push notifications',
        on: 'Push notifications on',
        turnOff: 'Turn off',
        blocked: 'Blocked in browser settings',
        blockedHint: 'Allow notifications for this site in your browser to turn them on.',
        turnOnHint: 'Get notified even when Studio is closed.',
        enableFailed: "Couldn't turn on push notifications. Please try again.",
        disableFailed: "Couldn't turn off push notifications. Please try again.",
        sendTest: 'Send a test',
        testSending: 'Sending a test…',
        testSent: "Test sent. No pop-up? On a Mac, open System Settings, then Notifications, then your browser. Turn off Summarize notifications, set Alert Style to Persistent, and make sure Focus is off.",
        testNotRegistered: "This browser isn't registered for push. Turn push off, then on again.",
        testExpired: 'This browser\'s push registration expired. Turn push on again.',
        testRejected: 'The push service refused the test ({status}): {detail}',
        testError: "Couldn't send the test: {detail}",
    },
}
